import {
    ContactComponentContactDiv,
    ContactComponentHeroMainDiv,
    ContactComponentMainDiv,
    ContactComponentTrustedDiv,
} from "../../styles/contactcomponentsstyles/contactcomponentstyles";
import { MarqueeMainDiv } from "../../styles/marqueestyles/marquestyle";
import IndexFaqComponent from "../indexcomponents/indexfaqcomponent";
import Footer from "../reusable/footer/footer";
import ButtonComponent from "../reusable/header/assetes/buttoncomponents/butttoncomponent";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import HeaderComponent from "../reusable/header/header";
import { ReactComponent as ArrowIcon } from "./assets/arrow-left-solid-full.svg"

const ContactComponent = () => {
    return (
        <ContactComponentMainDiv>
            <div className="header-holder">
                <HeaderComponent />
            </div>
            <ContactComponentHeroMainDiv>
                <div>
                    <div className="contact-container">
                        <div className="contact-header-container ">
                            <div className="contact-header-wrapper">
                                <div>
                                    <HeaderSpan text="contact us" />
                                </div>
                                <div className="contact-header-text-wrapper">
                                    <h1> We’re here to help you build smarter.</h1>
                                </div>

                            </div>
                            <div>
                                <div className="contact-header-text-wrapper ">
                                    <p>
                                        Got questions about Bugzi AI, pricing, or setting up your IDE? Our team is ready to assist with everything from technical support to business inquiries. Reach out today.
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div className="contact-form-container">

                            <ContactComponentContactDiv>
                                <div className="contact-info-header-text-container">
                                    <div className="contact-info-header-text-wrapper">
                                        <p><a href="tel: 050-333-333-334" target="_blank " rel="noopener " >  (050) 333-333-334 </a> </p>
                                    </div>
                                    <div className="contact-info-header-text-wrapper">

                                        <h3>
                                            <a href="mailto:hello@bugziai.com" target="_blank " rel="noopener">
                                                hello@bugziai.com

                                            </a>
                                        </h3>

                                    </div>

                                </div>

                                <div className="contact-address-info-container">
                                    <div className="contact-address-info-wrapper">

                                        {
                                            addressdata.map((item, index) => (
                                                <div className="contact-address-info-item-container">
                                                    <div className="contact-address-info-text-wrapper">
                                                        <p> Address</p>
                                                    </div>
                                                    <div className="contact-address-info-text-wrapper contact-address-info-address-text-wrapper">
                                                        <p> 123 Creative Lane, Washington, D.C., 20001

                                                        </p>
                                                    </div>
                                                </div>

                                            ))
                                        }


                                    </div>
                                    <div>
                                        <div className="contact-address-link-container">
                                            {
                                                data.map((item, index) => (
                                                    <a className="contact-link-wrapper" href="/">

                                                        <div className="contact-icon-wrapper">
                                                            <ArrowIcon />

                                                        </div>
                                                        <div className="contact-link-text-container">
                                                            <div className="contact-link-text-wrapper ">
                                                                <p> Instagram</p>
                                                            </div>
                                                            <div className="contact-link-text-wrapper ">

                                                                <p> Instagram</p>
                                                            </div>

                                                        </div>

                                                    </a>

                                                ))
                                            }



                                        </div>

                                    </div>

                                </div>

                            </ContactComponentContactDiv>
                            <div className="contact-form-left">
                                <form className="contact-form-wrapper">
                                    <div className="contact-form-input-container">

                                        <input className="contact-form-input-wrapper" placeholder="name *" required ></input>
                                    </div>
                                    <div className="contact-form-input-container">

                                        <input className="contact-form-input-wrapper" placeholder="e-mail *" required ></input>
                                    </div>
                                    <div className="contact-form-input-container">

                                        <input className="contact-form-input-wrapper" placeholder="phone "  ></input>
                                    </div>
                                    <div className="contact-form-input-container">

                                        <textarea className="contact-form-input-wrapper contact-form-text-area-wrapper " placeholder="message " maxLength={4} minLength={1} />
                                    </div>

                                </form>
                                <div className="contact-form-bottom">
                                    <div>
                                        <ButtonComponent title="submit" />
                                    </div>
                                    <div className="contact-form-bottom-text-wrapper">
                                        <p className="">
                                            By submitting this form you agree to our friendly
                                            <a href="/privacy"> privacy policy </a>
                                        </p>
                                    </div>

                                </div>

                            </div>



                        </div>
                    </div>
                </div>
            </ContactComponentHeroMainDiv>
            <ContactComponentTrustedDiv>
                <div>
                    <div className="contact-trusted-container">
                        <div>
                            <div>
                                <p>Trusted by 150,000+ users worldwide

                                </p>
                            </div>
                        </div>
                        <div className="contact-trusted-wrapper">
                            <MarqueeMainDiv gap={30} itemwidth={150} length={data.length} speed={10}>
                                <div>
                                    <ul className="marque-scroll-list">
                                        {
                                            data.map((item, index) => (
                                                <li className="contact-trusted-item-container">
                                                    <div className="contact-trusted-icon-wrapper">
                                                        <ArrowIcon />
                                                    </div>
                                                    <div>
                                                        <p>
                                                            PRODUCT
                                                        </p>
                                                    </div>

                                                </li>))
                                        }


                                        {
                                            data.map((item, index) => (
                                                <li className="contact-trusted-item-container">
                                                    <div className="contact-trusted-icon-wrapper">
                                                        <ArrowIcon />
                                                    </div>
                                                    <div>
                                                        <p>
                                                            PRODUCT
                                                        </p>
                                                    </div>

                                                </li>))
                                        }
                                        {
                                            data.map((item, index) => (
                                                <li className="contact-trusted-item-container">
                                                    <div className="contact-trusted-icon-wrapper">
                                                        <ArrowIcon />
                                                    </div>
                                                    <div>
                                                        <p>
                                                            PRODUCT
                                                        </p>
                                                    </div>

                                                </li>))
                                        }

                                    </ul>
                                </div>

                            </MarqueeMainDiv>
                        </div>

                    </div>

                </div>
            </ContactComponentTrustedDiv>

            <IndexFaqComponent />
            <div>
                <Footer />
            </div>
        </ContactComponentMainDiv>
    );
};

const addressdata = [
    "", "",
]
const data = [
    "", "", ""
]
export default ContactComponent;
